import React from 'react';
import { Copy } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { Button } from '../ui/button';

export const DossierReference = ({ reference, testId, administrative = false }) => {
  if (!reference) return null;
  return <div className="min-w-0 space-y-1" data-testid={testId}>
    <div className="flex flex-wrap items-center gap-1 text-xs text-[#2D5A4C]">
      <span>Dossier</span><span className="font-mono font-semibold break-all" data-testid={`${testId}-value`}>{reference}</span>
      <Button type="button" size="icon" variant="ghost" className="h-7 w-7 shrink-0" title="Copier la référence dossier" aria-label="Copier la référence dossier" data-testid={`${testId}-copy`} onClick={async (event) => {
        event.stopPropagation();
        try { await navigator.clipboard.writeText(reference); toast.success('Référence copiée'); }
        catch { toast.error('Copie impossible. Vous pouvez sélectionner la référence.'); }
      }}><Copy size={14} /></Button>
    </div>
    {administrative && <p className="text-xs text-amber-800" data-testid={`${testId}-notice`}>Référence administrative ajoutée après signature. Les documents signés conservent leur référence d’origine.</p>}
  </div>;
};